import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import {
  inlineCodeStyles,
  markdownListStyles,
  markdownParagraphStyles,
} from './ExplainExpression.styles';
import {
  MARKDOWN_BLOCK_TYPE,
  MARKDOWN_SEGMENT_TYPE,
  parseMarkdownBlocks,
} from './ExplainExpression.utils';

const renderSegment = (segment, index) => {
  const key = `${segment.type}-${index}`;

  if (segment.type === MARKDOWN_SEGMENT_TYPE.BOLD) {
    return <strong key={key}>{segment.value}</strong>;
  }

  if (segment.type === MARKDOWN_SEGMENT_TYPE.CODE) {
    return (
      <Box component="code" key={key} sx={inlineCodeStyles}>
        {segment.value}
      </Box>
    );
  }

  return <React.Fragment key={key}>{segment.value}</React.Fragment>;
};

const renderListItem = (segments, itemIndex) => (
  <li key={`item-${itemIndex}`}>{segments.map(renderSegment)}</li>
);

const renderBlock = (block, blockIndex) => {
  const key = `${block.type}-${blockIndex}`;

  if (block.type === MARKDOWN_BLOCK_TYPE.LIST) {
    return (
      <Box component="ul" key={key} sx={markdownListStyles}>
        {block.items.map(renderListItem)}
      </Box>
    );
  }

  return (
    <Box component="p" key={key} sx={markdownParagraphStyles}>
      {block.segments.map(renderSegment)}
    </Box>
  );
};

const ExplainMarkdownText = ({ text = null }) => {
  const blocks = parseMarkdownBlocks(text);

  return blocks.map(renderBlock);
};

ExplainMarkdownText.propTypes = {
  text: PropTypes.string,
};

export default ExplainMarkdownText;
